import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useRecoilValue } from 'recoil';
import { toast, ToastContainer } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { endpointState } from '../../recoil/atoms';

import BitPage from '../../components/BitPage/BitPage';
import BitHeaderFull from '../../components/BitHeader/BitHeaderFull';
import BitInput from '../../components/BitInput/BitInput';
import BitButton from '../../components/BitButton/BitButton';
import BitLinkButton from '../../components/BitLinkButton/BitLinkButton';

interface interfaceEmpreendimentos {
	value: {
		value: string | number;
		label: string;
		selected: boolean;
	}[];
	required: boolean;
}

const mockFeedPosts = [
	{
		id: 101,
		title: 'Novo Regulamento Interno da Piscina',
		description: 'Confira as novas regras de funcionamento, higiene e reserva da piscina para a temporada de verão.',
		author: { name: 'Associação Vista do Lago' },
		created_at: '2026-05-26',
	},
	{
		id: 102,
		title: 'Reunião de Condomínio Ordinária',
		description: 'Assembleia ordinária presencial e online para prestação de contas no salão de festas do Bloco A.',
		author: { name: 'Moderadora' },
		created_at: '2026-05-25',
	},
	{
		id: 103,
		title: 'Campanha de Vacinação contra a Gripe',
		description: 'Estaremos realizando a vacinação anual na portaria principal para moradores de todas as idades neste sábado.',
		author: { name: 'Administração' },
		created_at: '2026-05-24',
	},
	{
		id: 104,
		title: 'Manutenção Preventiva nos Elevadores',
		description: 'Interrupção temporária do serviço nos elevadores sociais entre 08:00 e 12:00 para vistoria técnica.',
		author: { name: 'Manutenção' },
		created_at: '2026-05-23',
	},
	{
		id: 105,
		title: 'Limpeza Semestral das Caixas d\'Água',
		description: 'Solicitamos o uso consciente de água durante o procedimento de higienização do reservatório central.',
		author: { name: 'Engenharia' },
		created_at: '2026-05-22',
	},
	{
		id: 106,
		title: 'Novo Horário de Funcionamento da Academia',
		description: 'A partir de junho a academia funcionará em horário estendido de segunda a domingo das 06:00 às 23:00.',
		author: { name: 'Comissão de Esportes' },
		created_at: '2026-05-21',
	},
	{
		id: 107,
		title: 'Feira Orgânica e Gastronômica na Praça Central',
		description: 'Venha prestigiar os produtores locais toda quinta-feira das 17:00 às 21:00.',
		author: { name: 'Eventos' },
		created_at: '2026-05-20',
	},
	{
		id: 108,
		title: 'Atualização do Regulamento para Animais de Estimação',
		description: 'Importante lembrete sobre o uso obrigatório de coleira nas áreas comuns e recolhimento de detritos.',
		author: { name: 'Administração' },
		created_at: '2026-05-19',
	},
	{
		id: 109,
		title: 'Torneio Interno de Beach Tennis',
		description: 'Inscrições abertas para as duplas masculinas, femininas e mistas no clube.',
		author: { name: 'Comissão de Esportes' },
		created_at: '2026-05-18',
	},
	{
		id: 110,
		title: 'Revitalização e Pintura das Fachadas',
		description: 'Início do cronograma de lavagem e pintura externa das torres A e B a partir da próxima semana.',
		author: { name: 'Síndico Geral' },
		created_at: '2026-05-17',
	},
	{
		id: 111,
		title: 'Instalação de Câmeras com Inteligência Artificial',
		description: 'Reforço do sistema de segurança com reconhecimento de placas e controle facial na portaria.',
		author: { name: 'Segurança' },
		created_at: '2026-05-16',
	},
	{
		id: 112,
		title: 'Campanha de Arrecadação do Agasalho 2026',
		description: 'Deposite suas doações de mantas e roupas de frio nos caixas localizados nos halls principais.',
		author: { name: 'Ação Social' },
		created_at: '2026-05-15',
	},
];

const ITEMS_PER_PAGE = 10;

const WhatsAppSend: React.FC = () => {
	const history = useHistory();
	const { urlEndpoint } = useRecoilValue(endpointState);
	const token = localStorage.getItem('token');
	const typeUser = localStorage.getItem('type');

	const [empreendimentos, setEmpreendimentos] = useState<interfaceEmpreendimentos>({
		value: [],
		required: true,
	});

	const [selectedDevelopment, setSelectedDevelopment] = useState<string>('');
	const [posts, setPosts] = useState<any[]>([]);
	const [selectedPost, setSelectedPost] = useState<any | null>(null);
	const [waText, setWaText] = useState<string>('');
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [loadingPosts, setLoadingPosts] = useState<boolean>(false);
	const [usingMockPosts, setUsingMockPosts] = useState<boolean>(false);
	const [showRequiredBallon, setShowRequiredBallon] = useState(false);

	// Filtros de busca (mesmos de /publicacoes: Título e Data de Cadastro)
	const [filterTitle, setFilterTitle] = useState<string>('');
	const [filterDate, setFilterDate] = useState<string>('');
	// Paginação (10 por página)
	const [currentPage, setCurrentPage] = useState<number>(1);

	// Carregar Empreendimentos no início
	useEffect(() => {
		axios
			.get(`${urlEndpoint}/developments`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then(response => {
				const fetchedData = response.data?.data?.data || response.data?.data || [];
				const allEmpreendimentos = Array.isArray(fetchedData) ? fetchedData : [fetchedData];

				const newValueEmpreendimentos: {
					value: string | number;
					label: string;
					selected: boolean;
				}[] = [];

				if (typeUser === 'Porteiro' && allEmpreendimentos.length > 0) {
					newValueEmpreendimentos.push({
						value: allEmpreendimentos[0].id,
						label: allEmpreendimentos[0].name,
						selected: true,
					});
					setSelectedDevelopment(String(allEmpreendimentos[0].id));
				} else {
					allEmpreendimentos.forEach((empreendimento: any) => {
						newValueEmpreendimentos.push({
							value: empreendimento.id,
							label: empreendimento.name,
							selected: false,
						});
					});
				}

				setEmpreendimentos({
					value: newValueEmpreendimentos,
					required: true,
				});
			})
			.catch(err => {
				console.error('Erro ao carregar empreendimentos', err);
				toast.error('Erro ao carregar lista de empreendimentos.');
			});
	}, [urlEndpoint, token, typeUser]);

	// Carregar posts de /publications quando empreendimento selecionado muda
	useEffect(() => {
		if (selectedDevelopment) {
			setLoadingPosts(true);
			setPosts([]);
			setSelectedPost(null);
			setWaText('');
			setFilterTitle('');
			setFilterDate('');
			setCurrentPage(1);

			axios
				.get(`${urlEndpoint}/publications`, {
					params: {
						development_id: selectedDevelopment,
					},
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then(response => {
					setLoadingPosts(false);
					const fetchedPosts = response.data?.data?.data || response.data?.data || response.data;
					if (Array.isArray(fetchedPosts) && fetchedPosts.length > 0) {
						setPosts(fetchedPosts);
						setUsingMockPosts(false);
					} else {
						// Se API retornar lista vazia, usa mock para permitir teste
						setPosts(mockFeedPosts);
						setUsingMockPosts(true);
					}
				})
				.catch(err => {
					console.error('Erro ao chamar /publications, usando fallback de mock', err);
					setLoadingPosts(false);
					setPosts(mockFeedPosts);
					setUsingMockPosts(true);
				});
		} else {
			setPosts([]);
			setSelectedPost(null);
		}
	}, [selectedDevelopment, urlEndpoint, token]);

	const handleSelectDevelopment = (e: React.FormEvent<HTMLSelectElement>) => {
		const targetValue = e.currentTarget.value;
		setSelectedDevelopment(targetValue);

		// Atualiza o estado de selected nos empreendimentos
		const updatedValue = empreendimentos.value.map(emp => ({
			...emp,
			selected: String(emp.value) === String(targetValue),
		}));
		setEmpreendimentos({
			value: updatedValue,
			required: true,
		});
	};

	const handleSelectPost = (post: any) => {
		setSelectedPost(post);
		const authorName =
			(typeof post.author === 'object' ? post.author?.name : post.author) ||
			post.author_name ||
			post.user_name ||
			post.user?.name ||
			'';

		const title = post.title || post.titulo || '';
		const body = post.body || post.description || post.descricao || '';

		let postContent = body;
		if (title && body && !body.toLowerCase().includes(title.toLowerCase())) {
			postContent = `${title} - ${body}`;
		} else if (!body) {
			postContent = title;
		}

		const truncatedContent = postContent.length > 200 ? `${postContent.slice(0, 200)}...` : postContent;
		const defaultWaText = authorName ? `*${authorName}*: ${truncatedContent}` : truncatedContent;
		setWaText(defaultWaText);
	};

	const handleSend = () => {
		if (!selectedDevelopment) {
			setShowRequiredBallon(true);
			toast.warn('Por favor, selecione um empreendimento.');
			return;
		}

		if (!selectedPost) {
			toast.warn('Por favor, selecione um post do feed.');
			return;
		}

		setIsLoading(true);

		const postId = selectedPost.id;
		const payload = {
			publication_id: Number(postId),
			developments_id: [Number(selectedDevelopment)],
			wa_text: waText,
		};

		axios
			.post(`${urlEndpoint}/publications/${postId}/send-whatsapp`, payload, {
				headers: {
					Authorization: `Bearer ${token}`,
					'Content-Type': 'application/json',
				},
			})
			.then(response => {
				setIsLoading(false);
				toast.success('Mensagem do WhatsApp enviada com sucesso!', {
					position: 'bottom-right',
					autoClose: 3000,
					hideProgressBar: true,
				});

				// Redireciona de volta após 2 segundos
				setTimeout(() => {
					history.push('/whatsapp');
				}, 1500);
			})
			.catch(err => {
				setIsLoading(false);
				console.error('Erro ao enviar mensagem', err);
				toast.error(
					`Erro ao disparar mensagem: ${
						err?.response?.data?.message || 'Tente novamente mais tarde.'
					}`,
					{
						position: 'bottom-right',
						autoClose: 4000,
						hideProgressBar: true,
					},
				);
			});
	};

	// Lógica de Filtragem (Título e Data de Cadastro)
	const filteredPosts = posts.filter(post => {
		const titleText = (post.title || post.titulo || '').toLowerCase();
		const bodyText = (post.body || post.description || post.descricao || '').toLowerCase();
		const matchTitle =
			!filterTitle ||
			titleText.includes(filterTitle.toLowerCase()) ||
			bodyText.includes(filterTitle.toLowerCase());

		const postDate = post.created_at || post.publication_date || post.date || '';
		const matchDate = !filterDate || postDate.includes(filterDate);

		return matchTitle && matchDate;
	});

	// Lógica de Paginação (10 itens por página)
	const totalPages = Math.ceil(filteredPosts.length / ITEMS_PER_PAGE) || 1;
	const safeCurrentPage = Math.min(Math.max(currentPage, 1), totalPages);
	const startIndex = (safeCurrentPage - 1) * ITEMS_PER_PAGE;
	const paginatedPosts = filteredPosts.slice(startIndex, startIndex + ITEMS_PER_PAGE);

	return (
		<BitPage>
			<BitHeaderFull
				label="Comunidade / Disparar Mensagem"
				icon="fab fa-whatsapp"
				hasIcon={true}
			/>

			<div className="p-5 mb-4 bg-white rounded shadow-sm">
				<h4 className="font-bold mb-4 text-xl flex items-center">
					<i className="fab fa-whatsapp text-bgGreen mr-2 text-2xl" />
					DISPARAR CAMPANHA WHATSAPP
				</h4>

				{/* PASSO 1 */}
				<h4 className="font-bold mb-4 flex items-center">
					<span className="bolinha-verde-numero">1</span>
					SELECIONE O EMPREENDIMENTO
				</h4>

				<div className="bloco-campos-novo-cadastro">
					<div className="mb-6">
						<BitInput
							label="Empreendimento"
							type="select"
							multipleSelect={false}
							placeholder="Selecione um empreendimento..."
							valuesSelect={empreendimentos.value}
							classField="grupo-campo-novos-registros max-w-xl"
							onChange={handleSelectDevelopment}
							disabled={isLoading}
						/>
					</div>
				</div>

				<div className="mb-10" />

				{/* PASSO 2 */}
				{selectedDevelopment && (
					<>
						<h4 className="font-bold mb-4 flex items-center">
							<span className="bolinha-verde-numero">2</span>
							SELECIONE O POST DO FEED
						</h4>

						<div className="bloco-campos-novo-cadastro">
							{loadingPosts ? (
								<div className="py-6 flex items-center justify-center text-gray-500">
									<i className="fas fa-spinner fa-spin mr-2 text-xl" />
									Carregando posts do feed...
								</div>
							) : posts.length === 0 ? (
								<div className="py-4 text-gray-500 italic">
									Nenhum post publicado encontrado para este empreendimento.
								</div>
							) : (
								<div>
									{usingMockPosts && (
										<div className="mb-4 p-3 bg-yellow-50 text-yellow-800 border border-yellow-200 rounded text-sm">
											<i className="fas fa-info-circle mr-2" />
											Nenhum post retornado pela API <strong>/publications</strong>. Exibindo posts sugeridos para demonstração.
										</div>
									)}

									{/* Filtros de Pesquisa (Mesmos filtros da tela de /publicacoes: Título e Data) */}
									<div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
										<div className="flex flex-wrap items-center justify-between gap-2 mb-3">
											<h5 className="font-semibold text-gray-700 text-sm flex items-center">
												<i className="fas fa-filter text-bgGreen mr-2" />
												Filtros de Pesquisa
											</h5>
											{(filterTitle || filterDate) && (
												<button
													type="button"
													onClick={() => {
														setFilterTitle('');
														setFilterDate('');
														setCurrentPage(1);
													}}
													className="text-xs text-red-600 hover:text-red-800 font-medium flex items-center transition-colors"
												>
													<i className="fas fa-times-circle mr-1" />
													Limpar Filtros
												</button>
											)}
										</div>
										<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
											<div>
												<label className="block text-xs font-semibold text-gray-600 mb-1">
													Título
												</label>
												<input
													type="text"
													placeholder="Buscar por título ou conteúdo..."
													value={filterTitle}
													onChange={e => {
														setFilterTitle(e.target.value);
														setCurrentPage(1);
													}}
													className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-bgGreen focus:border-bgGreen"
												/>
											</div>
											<div>
												<label className="block text-xs font-semibold text-gray-600 mb-1">
													Data de Cadastro
												</label>
												<input
													type="date"
													value={filterDate}
													onChange={e => {
														setFilterDate(e.target.value);
														setCurrentPage(1);
													}}
													className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-bgGreen focus:border-bgGreen"
												/>
											</div>
										</div>
									</div>

									{/* Renderização do Grid com Paginação */}
									{filteredPosts.length === 0 ? (
										<div className="py-6 text-center text-gray-500 italic bg-gray-50 rounded border border-dashed border-gray-200 mb-6">
											Nenhuma publicação encontrada para os filtros informados.
										</div>
									) : (
										<>
											<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
												{paginatedPosts.map(post => {
													const isSelected = selectedPost?.id === post.id;
													const authorName =
														typeof post.author === 'object'
															? post.author?.name
															: post.author || post.author_name || post.user_name || '';
													const rawText = post.body || post.description || post.descricao || '';
													const truncatedDescription = rawText.length > 150 ? `${rawText.slice(0, 150)}...` : rawText;

													return (
														<div
															key={post.id}
															onClick={() => !isLoading && handleSelectPost(post)}
															className={`p-4 border rounded-lg cursor-pointer transition-all duration-200 text-left flex flex-col justify-between h-52 ${
																isSelected
																	? 'border-bgGreen bg-green-50 shadow-md ring-2 ring-bgGreen ring-opacity-35'
																	: 'border-gray-200 hover:border-bgGreen hover:bg-gray-50'
															} ${isLoading ? 'opacity-60 cursor-not-allowed' : ''}`}
														>
															<div>
																{authorName && (
																	<span className="inline-block bg-gray-100 text-gray-700 text-xs font-semibold px-2 py-0.5 rounded mb-1.5 truncate max-w-full">
																		<i className="fas fa-user mr-1 text-gray-500" />
																		{authorName}
																	</span>
																)}
																<h5 className="font-semibold text-base text-gray-800 mb-1 truncate">
																	{post.title || post.titulo}
																</h5>
																<p className="text-gray-600 text-xs leading-relaxed overflow-hidden overflow-ellipsis line-clamp-3">
																	{truncatedDescription}
																</p>
															</div>
															<div className="flex justify-between items-center mt-2 border-t pt-2 border-gray-100">
																<span className="text-xs text-gray-400">
																	ID: {post.id}
																</span>
																<span className="text-xs text-gray-400">
																	{post.created_at || post.publication_date || ''}
																</span>
															</div>
														</div>
													);
												})}
											</div>

											{/* Bar da Paginação */}
											<div className="flex flex-col sm:flex-row items-center justify-between mt-6 pt-4 border-t border-gray-200 gap-4">
												<div className="text-sm text-gray-600">
													Exibindo <span className="font-semibold">{startIndex + 1}</span> a{' '}
													<span className="font-semibold">{Math.min(startIndex + ITEMS_PER_PAGE, filteredPosts.length)}</span> de{' '}
													<span className="font-semibold">{filteredPosts.length}</span> publicações
												</div>
												{totalPages > 1 && (
													<nav className="relative z-0 inline-flex shadow-sm -space-x-px pagination-bar" aria-label="Pagination">
														<button
															type="button"
															disabled={safeCurrentPage === 1}
															className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 ${
																safeCurrentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''
															}`}
															onClick={() => setCurrentPage(1)}
														>
															<i className="fas fa-chevron-left pl-1" />
															<i className="fas fa-chevron-left -ml-1 pr-1" />
														</button>
														<button
															type="button"
															disabled={safeCurrentPage === 1}
															className={`relative inline-flex items-center px-3 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 ${
																safeCurrentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''
															}`}
															onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
														>
															<i className="fas fa-chevron-left px-1" />
														</button>
														{Array.from({ length: totalPages }, (_, i) => i + 1).map(page => {
															const isActiveButton = page === safeCurrentPage ? 'active' : '';
															return (
																<button
																	key={page}
																	type="button"
																	className={`relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 ${isActiveButton}`}
																	onClick={() => setCurrentPage(page)}
																>
																	{page}
																</button>
															);
														})}
														<button
															type="button"
															disabled={safeCurrentPage === totalPages}
															className={`relative inline-flex items-center px-3 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 ${
																safeCurrentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''
															}`}
															onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
														>
															<i className="fas fa-chevron-right px-1" />
														</button>
														<button
															type="button"
															disabled={safeCurrentPage === totalPages}
															className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 ${
																safeCurrentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''
															}`}
															onClick={() => setCurrentPage(totalPages)}
														>
															<i className="fas fa-chevron-right pl-1" />
															<i className="fas fa-chevron-right -ml-1 pr-1" />
														</button>
													</nav>
												)}
											</div>
										</>
									)}
								</div>
							)}
						</div>
					</>
				)}

				{/* PASSO 3 */}
				{selectedPost && (
					<div className="transition-all duration-300">
						<div className="mb-10" />

						<h4 className="font-bold mb-4 flex items-center">
							<span className="bolinha-verde-numero">3</span>
							TEXTO DA MENSAGEM DO WHATSAPP
						</h4>

						<div className="bloco-campos-novo-cadastro">
							<div className="mb-6 max-w-2xl">
								<BitInput
									label="Texto Complementar (wa_text)"
									type="textarea"
									placeholder="Escreva aqui o texto adicional que será enviado junto com a mensagem do WhatsApp..."
									classField="grupo-campo-novos-registros"
									value={waText}
									onChange={(e: React.FormEvent<HTMLTextAreaElement>) =>
										setWaText(e.currentTarget.value)
									}
									disabled={isLoading}
								/>
							</div>

							<div className="text-left mt-8 flex items-center space-x-4">
								<BitLinkButton
									text="VOLTAR"
									buttonColor="#e2e8f0"
									textColor="#4a5568"
									link="/whatsapp"
								/>
								<BitButton
									text={isLoading ? 'ENVIANDO...' : 'ENVIAR MENSAGEM'}
									buttonColor="#3AABA2"
									textColor="#FFFFFF"
									type="fit px-10"
									classesBlockOption="inline-block"
									onClick={handleSend}
								/>
							</div>
						</div>
					</div>
				)}

				<ToastContainer
					position="bottom-right"
					autoClose={3000}
					hideProgressBar
					newestOnTop={false}
					closeOnClick={false}
					rtl={false}
					pauseOnFocusLoss
					draggable={false}
					pauseOnHover
				/>
			</div>
		</BitPage>
	);
};

export default WhatsAppSend;
